import client, { toFormData } from './client';

const unwrap = (promise) => promise.then((r) => r.data);

/** Список с серверной пагинацией: { items, total, page, perPage, lastPage } */
const list = (url, params) => unwrap(client.get(url, { params }));

export const statsApi = {
    get: () => unwrap(client.get('admin/stats')),
};

/**
 * Разделы устроены одинаково, поэтому CRUD собирается фабрикой.
 * Обновление идёт POST'ом на /{id} — форма уходит multipart вместе с файлом.
 */
const crud = (resource) => ({
    list: (params) => list(`admin/${resource}`, params),
    get: (id) => unwrap(client.get(`admin/${resource}/${id}`)).then((d) => d.item),
    create: (values, onProgress) =>
        unwrap(
            client.post(`admin/${resource}`, toFormData(values), {
                onUploadProgress: progressHandler(onProgress),
            })
        ),
    update: (id, values, onProgress) =>
        unwrap(
            client.post(`admin/${resource}/${id}`, toFormData(values), {
                onUploadProgress: progressHandler(onProgress),
            })
        ),
    remove: (id, { force = false } = {}) =>
        unwrap(client.delete(`admin/${resource}/${id}`, { params: force ? { force: 1 } : {} })),
});

const progressHandler = (onProgress) => {
    if (!onProgress) return undefined;
    return (event) => {
        if (!event.total) return;
        onProgress(Math.round((event.loaded * 100) / event.total));
    };
};

export const articlesApi = {
    ...crud('articles'),
    setVisibility: (id, view) =>
        unwrap(client.post(`admin/articles/${id}/visibility`, toFormData({ view }))),
};

export const educationalApi = crud('educational');
export const disertationsApi = crud('disertations');
export const releasesApi = crud('releases');

export const journalsApi = {
    list: (params) => list('admin/journals', params),
    create: (values) => unwrap(client.post('admin/journals', toFormData(values))),
    update: (id, values) => unwrap(client.put(`admin/journals/${id}`, values)),
    remove: (id, { force = false } = {}) =>
        unwrap(client.delete(`admin/journals/${id}`, { params: force ? { force: 1 } : {} })),
};

export const dictionaryApi = {
    list: (type, params) => list(`admin/dictionaries/${type}`, params),
    options: (type, params) =>
        unwrap(client.get(`admin/dictionaries/${type}/options`, { params })).then((d) => d.items),
    create: (type, values) => unwrap(client.post(`admin/dictionaries/${type}`, values)),
    update: (type, id, values) => unwrap(client.put(`admin/dictionaries/${type}/${id}`, values)),
    remove: (type, id, { force = false } = {}) =>
        unwrap(client.delete(`admin/dictionaries/${type}/${id}`, { params: force ? { force: 1 } : {} })),
};

export const authApi = {
    login: (email, password) => unwrap(client.post('login', { email, password })),
    me: () => unwrap(client.get('user')),
    logout: () => unwrap(client.post('logout')),
};

/**
 * Кафедры и институты живут на публичных эндпоинтах и используются
 * в формах учебных изданий как справочник.
 */
export const referenceApi = {
    departments: () => unwrap(client.get('educationalsdepartment')),
    institutes: () => unwrap(client.get('institute')).then((d) => d.items),
};
